import React from 'react';
import cls from 'classnames';
import './Tools.scss';

/**
 *
 * @typedef {{title: string, info: string}} tabInfo
 */

/**
 * @param {object} props
 * @param {tabInfo[]} props.items
 * @param {tabInfo} props.selected
 * @param {(tab: tabInfo) => void} props.onChangeItems
 *
 */


function Tool_tabs({
  items,
  selected,
  onChangeItems
}) {
  return (
    <div className="Tool Tool__tabs d-flex">
      {
        items.map((e, index) => (
          <a
            key={index}
            className={cls(
              "Tool__tabs__item text-center d-flex col justify-content-center align-items-center pt-3 pb-3",
              selected.info === e.info ? 'Tool__tabs__item_seleted' : '',
              selected.info,
              e.className
            )}
            onClick={() => {
              onChangeItems(e)
            }}
          >
            {e.title}
          </a>
        ))
      }
    </div>
  )
}

export default Tool_tabs;
